import React from 'react'

import Topup, { getTopupType, type TopupType } from '@/app/module/campaigns/component/topup'
import type { LocalTopupAction, TopupMessage } from '@/app/module/campaigns/types'
import type { PersonalizationType } from '@/app/types'

type Props = {
  item: TopupMessage
  personalizationList: PersonalizationType

  changeHandler: (item: Partial<TopupMessage>, changed?: boolean) => void
}

const CampaignContentTopup: React.FC<Props> = ({ personalizationList, changeHandler, item }) => {
  const { desiredAmount = '', maxAmount = '' } = item.topup
  const [topupType, setTopupType] = React.useState<TopupType>(getTopupType(desiredAmount, maxAmount))
  const setTopup = React.useCallback(
    (topup: LocalTopupAction['topup']) => {
      const newTopup = {
        ...item.topup,
        maxAmount: topup.maxAmountTemplated || topup.maxAmount || '',
        desiredAmount: topup.desiredAmountTemplated,
      }
      if (newTopup.desiredAmount !== item.topup.desiredAmount || newTopup.maxAmount !== item.topup.maxAmount) {
        changeHandler({ ...item, topup: newTopup })
      }
    },
    [item, changeHandler],
  )

  return (
    <Topup
      desiredAmountTemplated={desiredAmount}
      maxAmount={maxAmount}
      personalizationList={personalizationList}
      topupType={topupType}
      setTopup={setTopup}
      setTopupType={setTopupType}
    />
  )
}

export default CampaignContentTopup
